import React, { useState } from "react";
import "./Profile.css";
import Image from "../../components/Image";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../contexts/AuthProvider";

// Removed AuthContext import

import { API_URL } from "../../utils/config";
const baseUrl = API_URL;
const PersonalInfo = ({ profile, edit }) => {
  const { t } = useTranslation("profile");
  const { isAuthenticated } = useAuth();
  const [firstName, setFirstName] = useState(profile.firstName);
  const [familyName, setFamilyName] = useState(profile.familyName);
  const [email] = useState(profile.email);
  const [company, setCompany] = useState(profile.company);
  const [phoneNumber, setPhoneNumber] = useState(profile.phoneNumber);
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(profile?.image || "");
  const [Errors, setErrors] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();


  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.type.startsWith("image/")) {
      setFile(selectedFile);
      setPreview(URL.createObjectURL(selectedFile));
    }
  };
  
  const getLangFromLocalStorage = () => {
    return localStorage.getItem("language") || "en";
  };


  const confirm = () => {
    return (
      file ||
      firstName !== profile.firstName ||
      familyName !== profile.familyName ||
      phoneNumber !== profile.phoneNumber ||
      company !== profile.company
    );
  };

  const isValid = () => {
    return !(firstName.length === 0 || familyName.length === 0 || phoneNumber.length === 0);
  };

  const handleNavigateWithParams = (path) => {
    navigate({
      pathname: location.pathname,
      search: `?path=${path}`,
    });
  };

  const handleSubmit = () => {
    if (!edit) {
      handleNavigateWithParams("editProfile");
    } else {
      updateProfile();
    }
  };

  const updateProfile = async () => {
    if (!confirm()) return;
    if (!isValid()) return;
    const loadingToast = toast.loading(t("toast.processing"));
    try {
      if (!isAuthenticated) throw new Error("No authentication token found. Please log in again.");

      let formData = new FormData();
      if (firstName !== profile.firstName) formData.append("firstName", firstName);
      if (familyName !== profile.familyName) formData.append("familyName", familyName);
      if (company !== profile.company) formData.append("company", company);
      if (phoneNumber !== profile.phoneNumber) formData.append("phoneNumber", phoneNumber);
      if (file) formData.append("image", file);

      const response = await fetch(`${baseUrl}/api/v1/attnd-supplier/auth/update-profile`, {
        method: "PUT",
        credentials: "include",
        headers: {
          lang: getLangFromLocalStorage(),

        },
        body: formData,
      });

      if (!response.ok) {
        if (response.status === 401) {
          navigate("/login");
          throw new Error("Unauthorized access. Please log in again.");
        }
        const error = await response.json();
        setErrors(error);
        const errorMessage =
          error.error ||
          error.errors?.[0]?.firstName ||
          error.errors?.[0]?.familyName ||
          error.errors?.[0]?.company ||
          error.errors?.[0]?.phoneNumber ||
          error.errors?.[0]?.image ||
          "An unknown error occurred.";
        throw new Error(errorMessage);
      }

      const userData = {
        ...profile,
        firstName: firstName || profile.firstName,
        familyName: familyName || profile.familyName,
        email: profile.email,
        image: preview,
      };

      localStorage.setItem("user", JSON.stringify(userData));
      setErrors([]);

      toast.update(loadingToast, {
        render: t("toast.success"),
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      navigate(-1);
    } catch (error) {
      console.error(error);
      toast.update(loadingToast, {
        render: t("toast.error", { message: error.message }),
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
    }
  };

  const inputClass =
    "box-border w-full h-[48px] bg-white border border-white rounded-sm px-3.5 flex items-center font-inter font-normal font-light text-base leading-[22px] text-[#464646]";

  return (
    <div className="p-11 px-6 box-border gap-6 flex flex-col">
      <label className="w-fit h-[120px] rounded-full">
        <div>
          <div style={edit ? { cursor: "pointer" } : {}}>
            {preview ? (
              <Image Class="w-[120px] h-[120px] rounded-full" src={preview} />
            ) : (
              <svg
                className="w-[120px] h-[120px]"
                width="101"
                height="100"
                viewBox="0 0 101 100"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect x="0.5" width="100" height="100" rx="50" fill="white" />
                <path
                  d="M47.5 48.75C45.98 48.75 44.75 47.52 44.75 46C44.75 44.48 45.98 43.25 47.5 43.25C49.02 43.25 50.25 44.48 50.25 46C50.25 47.52 49.02 48.75 47.5 48.75ZM47.5 44.75C46.81 44.75 46.25 45.31 46.25 46C46.25 46.69 46.81 47.25 47.5 47.25C48.19 47.25 48.75 46.69 48.75 46C48.75 45.31 48.19 44.75 47.5 44.75Z"
                  fill="#888888"
                />
                <path
                  d="M53.5 60.75H47.5C42.07 60.75 39.75 58.43 39.75 53V47C39.75 41.57 42.07 39.25 47.5 39.25H51.5C51.91 39.25 52.25 39.59 52.25 40C52.25 40.41 51.91 40.75 51.5 40.75H47.5C42.89 40.75 41.25 42.39 41.25 47V53C41.25 57.61 42.89 59.25 47.5 59.25H53.5C58.11 59.25 59.75 57.61 59.75 53V48C59.75 47.59 60.09 47.25 60.5 47.25C60.91 47.25 61.25 47.59 61.25 48V53C61.25 58.43 58.93 60.75 53.5 60.75Z"
                  fill="#888888"
                />
                <path
                  d="M59.75 43.75H54.25C53.84 43.75 53.5 43.41 53.5 43C53.5 42.59 53.84 42.25 54.25 42.25H59.75C60.16 42.25 60.5 42.59 60.5 43C60.5 43.41 60.16 43.75 59.75 43.75Z"
                  fill="#888888"
                />
                <path
                  d="M57 46.5C56.59 46.5 56.25 46.16 56.25 45.75V40.25C56.25 39.84 56.59 39.5 57 39.5C57.41 39.5 57.75 39.84 57.75 40.25V45.75C57.75 46.16 57.41 46.5 57 46.5Z"
                  fill="#888888"
                />
                <path
                  d="M41.1703 57.7001C40.9303 57.7001 40.6903 57.5801 40.5503 57.3701C40.3203 57.0301 40.4103 56.5601 40.7503 56.3301L45.6803 53.0201C46.7603 52.3001 48.2503 52.3801 49.2303 53.2101L49.5603 53.5001C50.0603 53.9301 50.9103 53.9301 51.4003 53.5001L55.5603 49.9301C56.6303 49.0201 58.2903 49.0201 59.3603 49.9301L60.9903 51.3301C61.3003 51.6001 61.3403 52.0701 61.0703 52.3901C60.8003 52.7001 60.3303 52.7401 60.0103 52.4701L58.3803 51.0701C57.8803 50.6401 57.0303 50.6401 56.5403 51.0701L52.3803 54.6401C51.3203 55.5501 49.6503 55.5501 48.5803 54.6401L48.2503 54.3501C47.7903 53.9601 47.0303 53.9201 46.5203 54.2701L41.6003 57.5801C41.4603 57.6601 41.3103 57.7001 41.1703 57.7001Z"
                  fill="#888888"
                />
              </svg>
            )}
            {edit && (
              <svg
                style={{
                  width: "36px",
                  height: "36px",
                  position: "relative",
                  left: "85px",
                  top: "-30px",
                }}
                width="36"
                height="36"
                viewBox="0 0 36 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="36" height="36" rx="18" fill="white" />
                <path
                  d="M12.6176 24.2666C12.1093 24.2666 11.6343 24.0916 11.2926 23.7666C10.8593 23.3583 10.651 22.7416 10.726 22.075L11.0343 19.375C11.0926 18.8666 11.401 18.1916 11.7593 17.825L18.601 10.5833C20.3093 8.77496 22.0926 8.72496 23.901 10.4333C25.7093 12.1416 25.7593 13.925 24.051 15.7333L17.2093 22.975C16.8593 23.35 16.2093 23.7 15.701 23.7833L13.0176 24.2416C12.876 24.25 12.751 24.2666 12.6176 24.2666ZM21.276 10.425C20.6343 10.425 20.076 10.825 19.5093 11.425L12.6676 18.675C12.501 18.85 12.3093 19.2666 12.276 19.5083L11.9676 22.2083C11.9343 22.4833 12.001 22.7083 12.151 22.85C12.301 22.9916 12.526 23.0416 12.801 23L15.4843 22.5416C15.726 22.5 16.126 22.2833 16.2926 22.1083L23.1343 14.8666C24.1676 13.7666 24.5426 12.75 23.0343 11.3333C22.3676 10.6916 21.7926 10.425 21.276 10.425Z"
                  fill="#6609F8"
                />
                <path
                  d="M22.4497 17.125C22.433 17.125 22.408 17.125 22.3914 17.125C19.7914 16.8667 17.6997 14.8917 17.2997 12.3084C17.2497 11.9667 17.483 11.65 17.8247 11.5917C18.1664 11.5417 18.483 11.775 18.5414 12.1167C18.858 14.1334 20.4914 15.6834 22.5247 15.8834C22.8664 15.9167 23.1164 16.225 23.083 16.5667C23.0414 16.8834 22.7664 17.125 22.4497 17.125Z"
                  fill="#6609F8"
                />
                <path
                  d="M25.5 26.9583H10.5C10.1583 26.9583 9.875 26.6749 9.875 26.3333C9.875 25.9916 10.1583 25.7083 10.5 25.7083H25.5C25.8417 25.7083 26.125 25.9916 26.125 26.3333C26.125 26.6749 25.8417 26.9583 25.5 26.9583Z"
                  fill="#6609F8"
                />
              </svg>
            )}
          </div>
          <input
            style={{ display: "none" }}
            type="file"
            name="logo"
            disabled={!edit}
            accept="image/*"
            onChange={handleFileChange}
          />
        </div>
      </label>

      <div className="flex flex-col items-center p-0 gap-8 box-border w-[755px] h-[520px]">
        <div className="box-border flex flex-col items-start p-0 gap-4 w-[755px] self-stretch">
          <div className="flex flex-row items-start p-0 gap-6 w-[755px] h-[78px] self-stretch">
            <div className="flex flex-col w-[365.5px] h-[78px] gap-2">
              <h5 className="h-[22px] flex font-inter font-normal text-base leading-[22px] items-center text-center text-[#292929] p-0 m-0">
                {t("firstName")}
              </h5>
              <input
                className={inputClass}
                type="text"
                required
                disabled={!edit}
                style={Errors?.errors?.[0]?.firstName ? { border: "1px solid red" } : {}}
                value={firstName}
                onChange={(e) => {
                  setErrors([]);
                  setFirstName(e.target.value);
                }}
              />
            </div>
            <div className="flex flex-col w-[365.5px] h-[78px] gap-2">
              <h5 className="h-[22px] flex font-inter font-semibold text-base leading-[22px] items-center text-center text-[#292929] p-0 m-0">
                {t("lastName")}
              </h5>
              <input
                className={inputClass}
                type="text"
                required
                disabled={!edit}
                style={Errors?.errors?.[0]?.familyName ? { border: "1px solid red" } : {}}
                value={familyName}
                onChange={(e) => {
                  setErrors([]);
                  setFamilyName(e.target.value);
                }}
              />
            </div>
          </div>

          <div className="flex flex-col w-full h-[78px] gap-2">
            <h5 className="h-[22px] flex font-inter font-semibold text-base leading-[22px] items-center text-center text-[#292929] p-0 m-0">
              {t("email")}
            </h5>
            <input
              className={inputClass}
              type="text"
              required
              disabled
              value={email}
            />
          </div>

          <div className="flex flex-col w-full h-[78px] gap-2">
            <h5 className="h-[22px] flex font-inter font-semibold text-base leading-[22px] items-center text-center text-[#292929] p-0 m-0">
              {t("company")}
            </h5>
            <input
              className={inputClass}
                type="text"
                required
                disabled={!edit}
                style={Errors?.errors?.[0]?.company ? { border: "1px solid red" } : {}}
                value={company}
                onChange={(e) => {
                  setErrors([]);
                  setCompany(e.target.value);
                }}
            />
          </div>

          <div className="flex flex-col w-full h-[78px] gap-2">
            <h5 className="h-[22px] flex font-inter font-semibold text-base leading-[22px] items-center text-center text-[#292929] p-0 m-0">
              {t("phoneNumber")}
            </h5>
            <input
              className={inputClass}
              type="text"
              required
              disabled={!edit}
              style={Errors?.errors?.[0]?.phoneNumber ? { border: "1px solid red" } : {}}
              value={phoneNumber}
              onChange={(e) => {
                setErrors([]);
                setPhoneNumber(e.target.value);
              }}
            />
          </div>
        </div>

        <button
          onClick={handleSubmit}
          className="w-full h-[48px] rounded-sm self-stretch flex justify-center font-inter font-bold text-base leading-[22px] items-center cursor-pointer border-none text-[#FFFFFF] bg-[#6609F8]"
          style={(confirm() && isValid()) || !edit ? {} : { background: "#888888" }}
        >
          {edit ? t("buttons.save") : t("buttons.edit")}
        </button>

        <button
          onClick={() => navigate(-1)}
          className="w-full h-[48px] rounded-sm self-stretch flex justify-center font-inter font-bold text-base leading-[22px] items-center cursor-pointer text-[#6609F8] bg-[#F4F1FF] border border-custom-purple"
        >
          {t("buttons.cancel")}
        </button>
      </div>

      <ToastContainer />
    </div>
  );
};

export default PersonalInfo;
